<!-- src/components/icons/HamburgerIcon.vue -->
<template>
    <svg class="project-menu-svg" width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="5" cy="12" r="2" stroke="currentColor" stroke-width="1.5"></circle> <circle cx="12" cy="12" r="2" stroke="currentColor" stroke-width="1.5"></circle> <circle cx="19" cy="12" r="2" stroke="currentColor" stroke-width="1.5"></circle> </g></svg>
</template>
  
<script>
  export default {
    name: "LotoutIcon",
    props: {
      width: {
        type: String,
        default: "20px",
      },
      height: {
        type: String,
        default: "20px",
      },
      strokeColor: {
        type: String,
        default: "#ffffff",
      },
      strokeWidth: {
        type: [String, Number],
        default: 1.5,
      },
    },
  };
</script>